import { inMobileWebView } from '@/utils/mobileApp.js'
import axios from './util/axios.js'

const maybeRequestAuthToken = (data) => inMobileWebView() ? { ...data, getAuthToken: true } : data

export function postLogin(data) {
  return axios.post('/api/login/', maybeRequestAuthToken(data))
}

export function postLogout() {
  return axios.post('/api/logout/')
}

export function postSignup(data) {
  return axios.post('/api/signup/', maybeRequestAuthToken(data))
}
